import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const LinkChainIcon24 = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.5 16.5-3 3a3.54 3.54 0 0 1-5 0 3.54 3.54 0 0 1 0-5l3-3M12 7l3-3a3.54 3.54 0 0 1 5 0 3.54 3.54 0 0 1 0 5l-3 3m-6 1 2-2"
    />
  </Svg>
);
export default LinkChainIcon24;
